export enum PromoCode {
  PROMO_NET = 2562,
  PROMO_OFF = 2563,
  PROMO_PORCENT_OFF = 2564,
  PROMO_RAC = 2565,
  PROMO_SUPER_PROMO = 2566,
  PROMO_2_X_1 = 2567,
}
